/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';


@Injectable({ providedIn: 'root' })
export class EventsApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCacheEvents()` */
  static readonly GetCacheEventsPath = '/api/v1/events/{cacheId}';

  /**
   * Get server sent events for user cache updates.
   *
   * Establish a server-sent events connection that sends a notifcation if the user's cacheId changes.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCacheEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCacheEvents$Response(
    params: {
      cacheId: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, EventsApiClient.GetCacheEventsPath, 'get');
    if (params) {
      rb.path('cacheId', params.cacheId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Get server sent events for user cache updates.
   *
   * Establish a server-sent events connection that sends a notifcation if the user's cacheId changes.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCacheEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCacheEvents(
    params: {
      cacheId: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.getCacheEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
